import { useEffect } from 'react' // eslint-disable-line
import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import Warning from '../../../../media/images/warning.svg'
import InfoBlueBg from '../../../../media/shared-access/ic-bluebg-info.svg'
import { useState } from 'react'
import '../styles/connectAccount.scss'
import { getNylasOauthUrl } from '../core/_requests'
import { useAuth } from '../../auth'
import { toast } from 'react-toastify'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import brandingConfig from '../../../../config/brandingConfig'

export default function ConnectAccountModal({
  isActive,
  setIsActive,
  handleIsActive,
  accountType,
  connectedAccount,
}: any) {
  const { formatMessage } = useIntl()
  const { companyId, currentUser } = useAuth()
  const [agree, setAgree] = useState(false)
  const [connecting, setConnecting] = useState(false)

  function handleAgree() {
    setAgree(() => !agree)
  }

  const redirectToNylasOauthUrl = async (provider: string) => {
    setConnecting(true)
    try {
      const {
        data: { success, data, errors },
      } = await getNylasOauthUrl(provider, companyId)
      if (success) {
        if (data.auth_url) {
          localStorage.setItem('NYLAS_PROVIDER', provider)
          window.open(data.auth_url)
          setIsActive(false)
          setConnecting(false)
          setAgree(false)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.RedirectedToNylasSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                provider,
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        } else {
          console.error('OAuth URL is missing.')
          toast.error(formatMessage({ id: 'OAuth URL is missing.' })) // Optional: Display this error using a toast if appropriate in your application context.
          setConnecting(false)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.RedirectedToNylasFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                provider,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: 'OAuth URL is missing.',
              },
            },
          })
        }
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
        setConnecting(false)
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.RedirectedToNylasFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              provider,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: 'OAuth URL is missing.',
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      setConnecting(false)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.RedirectedToNylasFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            provider,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: 'OAuth URL is missing.',
          },
        },
      })
    }
  }

  return (
    <>
      <Modal
        show={isActive}
        onHide={() => {
          setAgree(false)
          setIsActive(false)
          setConnecting(false)
        }}
        size='lg'
      >
        <Modal.Header closeButton>
          <h2 className='connect-acc-header'>
            {formatMessage({ id: 'Connect Google or Microsoft Account' })}
          </h2>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex justify-content-center gap-2'>
            <img src={Warning} alt='Warning' />
          </div>
          <div className='d-flex '>
            <div className='me-2'>
              <img src={InfoBlueBg} alt='info-blue-tag' />
            </div>
            <p className='connect-acc-description'>
              {formatMessage({
                id: `You are about to connect your Google Workspace or Microsoft 365 account with ${brandingConfig.brandName}. This connection will facilitate collaborative efforts for fundraising and investor relationship management.`,
              })}
            </p>
          </div>
          <div className='d-flex '>
            <div className='me-2'>
              <img src={InfoBlueBg} alt='info-blue-tag' />
            </div>
            <p className='connect-acc-description'>
              {formatMessage({
                id: 'The same account will be used in the "Shared Access" section for the Team Inbox, Team Calendar, and Team Contacts. It will be accessible to other team members with specific roles and permissions.',
              })}
            </p>
          </div>
          <div className='d-flex '>
            <div className='me-2'>
              <img src={InfoBlueBg} alt='info-blue-tag' />
            </div>
            <p className='connect-acc-description'>
              {formatMessage({
                id: "Don't connect an account that you do not want to share. We highly recommend creating a new account like invest@yourcompany.com or investor-relation@yourcompany.com.",
              })}
            </p>
          </div>
          <div className='d-flex '>
            <div className='me-2'>
              <img src={InfoBlueBg} alt='info-blue-tag' />
            </div>
            <p className='connect-acc-description'>
              {formatMessage({
                id: 'You will be asked to grant full permissions for Email, Calendar, and Contacts. Please approve all the permissions.',
              })}
            </p>
          </div>
          <div className='d-flex mt-4 mt-md-0'>
            <input className='me-2 form-check-input' type='checkbox' onClick={handleAgree} />
            <p className='m-0'>
              {formatMessage({ id: 'I understand and accept the above points.' })}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className='p-0'>
          <div className='d-md-flex  gap-3 m-5 justify-content-end w-100 w-md-auto'>
            <button
              type='button'
              className={`order-2 btn bg-primary text-white custom-button-property fw-normal font-size-13 w-md-auto w-100 me-2 ${!agree && 'disabled'
                } `}
              style={{ padding: '15px 40px' }}
              onClick={() => {
                redirectToNylasOauthUrl(accountType)
              }}
              disabled={!agree || connecting}
            >
              <span className='indicator-label font-size-13 p-0'>
                {connecting
                  ? formatMessage({ id: 'Connecting...' })
                  : formatMessage({ id: 'Connect Now' })}
              </span>
            </button>
            <button
              type='button'
              className='order-1 btn bg-light fw-normal text-muted custom-button-property font-size-13 w-md-auto w-100 mb-2 mb-md-0'
              style={{ padding: '15px 40px' }}
              onClick={() => {
                handleIsActive()
                setAgree(false)
                setConnecting(false)
              }}
              disabled={connecting}
            >
              {formatMessage({ id: 'Close' })}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}
